export default "__VITE_ASSET__DNvbPFic__"